<div class="flex-col justify-center items-center gap-4">
  <mat-spinner diameter="48"></mat-spinner>
  @if (showDurationDisclaimer$ | async) {
    <span @fadeIn @slideUpDown style="color: gray;">
      {{ 'spinner.description' | translate }}
    </span>
  }
</div>
